if(!customElements.get('custom-marquee')) {
    class CustomMarquee extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.blocks = this.querySelectorAll('.marquee-block');
            this.backgroundMedia = this.querySelectorAll('.marquee__background-media-item');

            this.blocks.forEach((block) => {
                block.addEventListener('mouseover', () => {
                    const blockId = block.dataset.blockId;

                    this.backgroundMedia.forEach((mediaItem) => {
                        if(mediaItem.dataset.blockId === blockId){
                            this.showBackgroundMedia(mediaItem);
                        } else {
                            this.hideBackgroundMedia(mediaItem);
                        }
                    });

                    this.blocks.forEach((otherBlock) => {
                        if(otherBlock !== block){
                            otherBlock.classList.add('marquee-block-not-active');
                        }else{
                            otherBlock.classList.remove('marquee-block-not-active');
                        }
                    });
                });

                block.addEventListener('mouseout', () => {
                    this.backgroundMedia.forEach((mediaItem) => {
                        this.hideBackgroundMedia(mediaItem);
                    });

                    this.blocks.forEach((otherBlock) => {
                        otherBlock.classList.remove('marquee-block-not-active');
                    });
                });
            });

            this.initMobileDefaultActive();
        }

        initMobileDefaultActive(){
            const isMobile = () =>
                window.matchMedia("(pointer: coarse)").matches ||
                window.matchMedia("(max-width: 48rem)").matches;

            // Returns the block currently "leading" the visible area — its start edge
            // has entered the parent viewport even if its trailing edge is still cut off.
            const getCurrentActiveBlock = () => {
                const parent = this.blocks?.[0]?.closest('.marquee__content-wrapper');

                if (!parent) return this.blocks?.[0] || null;

                const parentRect = parent.getBoundingClientRect();
                const tolerance = 1;

                // Detect scroll axis: horizontal if parent scrolls horizontally, vertical otherwise
                const isHorizontal = parent.scrollWidth > parent.clientWidth;

                let bestBlock = null;
                let bestDistance = Infinity;

                for (const block of this.blocks) {
                    const r = block.getBoundingClientRect();

                    if (isHorizontal) {
                        // Block's left edge has entered (is at or past parent's left),
                        // and its right edge hasn't fully scrolled past parent's left
                        const entered = r.left >= parentRect.left - tolerance;
                        const notGone = r.right > parentRect.left + tolerance;

                        if (entered && notGone) {
                            const distance = r.left - parentRect.left;
                            if (distance < bestDistance) {
                                bestDistance = distance;
                                bestBlock = block;
                            }
                        }
                    } else {
                        // Vertical: same logic on top/bottom axis
                        const entered = r.top >= parentRect.top - tolerance;
                        const notGone = r.bottom > parentRect.top + tolerance;

                        if (entered && notGone) {
                            const distance = r.top - parentRect.top;
                            if (distance < bestDistance) {
                                bestDistance = distance;
                                bestBlock = block;
                            }
                        }
                    }
                }

                return bestBlock || this.blocks?.[0] || null;
            };

            const setActiveBlock = (block) => {
                if (!block) return;

                const blockId = block.dataset.blockId;

                this.backgroundMedia.forEach((mediaItem) => {
                if (mediaItem.dataset.blockId === blockId) {
                    this.showBackgroundMedia(mediaItem);
                } else {
                    this.hideBackgroundMedia(mediaItem);
                }
                });

                this.blocks.forEach((otherBlock) => {
                    otherBlock.classList.toggle("marquee-block-not-active", otherBlock !== block);
                });
            };

            const apply = () => {
                if (!isMobile()) return; // only do this on mobile
                setActiveBlock(getCurrentActiveBlock());
            };

      
            setInterval(() => {
                apply();
            }, 500);

            window.addEventListener("resize", apply, { passive: true });
            window.addEventListener("orientationchange", apply, { passive: true });
        }

        hideBackgroundMedia(mediaItem){
            mediaItem.classList.remove('opacity-100');
            mediaItem.classList.add('opacity-0');

            if(mediaItem.classList.contains('marquee__background-media--video')){
                const video = mediaItem.querySelector('video');
                if(video){
                    this.stopVideo(video);
                }
            }
        }

        showBackgroundMedia(mediaItem){
            mediaItem.classList.remove('opacity-0');
            mediaItem.classList.add('opacity-100');

            if(mediaItem.classList.contains('marquee__background-media--video')){
                const video = mediaItem.querySelector('video');
                if(video){
                    this.playVideo(video);
                }
            }
        }

        playVideo(video){
            if(typeof video === 'undefined') return;
            video.addEventListener("loadeddata", e => {
                video.classList.add('loaded');
                video.play();
            });

            if(video.readyState >= 2){
                video.classList.add('loaded');
                video.play();
            }
        }

        stopVideo(video){
            video.pause();
            this.resetVideo(video);
        }

        resetVideo(video){
            if(video.readyState > 0){
                video.currentTime = 0;
            }else{
                video.addEventListener(
                    "loadedmetadata",
                    function onMeta() {
                        video.currentTime = 0;
                        video.removeEventListener("loadedmetadata", onMeta);
                    },
                    { once: true });
            }
        }
    }

    customElements.define('custom-marquee', CustomMarquee);
}